// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"3321":"df1c800b","3413":"cb245d9f","8847":"12de4733"}[chunkId] + ".css";
};